import { useFieldArray, useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import InputComponent from './component';

const Input = ({
  name,
  required = false,
  defaultValue = [],
  formatterMap,
  nameMap,
  readOnly,
  value,
  isLoading,
  isSingleOption = false,
  onInteract,
  ...restProps
}) => {
  const {
    control,
    setValue,
    setFocus,
    getValues,
    reset,
    resetField,
  } = useFormContext() || {};

  const {
    remove, fields, update, append,
  } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name, // unique name for your Field Array,
    shouldUnregister: true,
  });
  const alreadyExistingField = fields.find((field) => typeof field.value === 'string' && nameMap?.[field.value]);

  useEffect(() => {
    if(alreadyExistingField) {
      const fixedValue = nameMap?.[alreadyExistingField.value];
      const fixedValueIndex = fields.findIndex((i) => i.id === alreadyExistingField.id);

      if(fields.find((field) => field.value === fixedValue)) {
        remove(fixedValueIndex);
      } else {
        update(fixedValueIndex, { value: fixedValue });
      }
    }
  }, [alreadyExistingField]);

  return (
    <InputComponent
      {...restProps}
      formatterMap={formatterMap}
      nameMap={nameMap}
      append={(tag) => {
        if(isSingleOption) {
          setValue(name, [tag], {
            shouldValidate: true,
            shouldTouch: true,
            shouldDirty: true,
          });
        } else {
          setValue(name, [...fields, tag], {
            shouldValidate: true,
            shouldTouch: true,
            shouldDirty: true,
          });
        }

        if (onInteract) onInteract(name);
        setFocus(name);
      }}
      remove={(index) => {
        remove(index);
        if (onInteract) onInteract(name);
      }}
      required={required}
      name={name}
      fields={fields}
      readOnly={readOnly}
    />
  );
};

export default Input;
